import { render, staticRenderFns } from "./UpdatesList.vue?vue&type=template&id=83cf99ba&scoped=true"
import script from "./UpdatesList.vue?vue&type=script&lang=js"
export * from "./UpdatesList.vue?vue&type=script&lang=js"
import style0 from "./UpdatesList.vue?vue&type=style&index=0&id=83cf99ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cf99ba",
  null
  
)

export default component.exports